import SettingBase from '../settings/util/SettingBase'

class ServiceSettingsController extends SettingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "service-settings";
        this.ssid = "service-checklist";
        this.acl = {};
        this.hasACL = {};
        this.hasServiceCheckListACL = {};
    }
    $onInit() {
        super.$onInit()
        for (let key in this.acl['setting-' + this.id]) {
            this.hasACL[this.acl['setting-' + this.id][key]] = true;
        }

        for (let key in this.acl['setting-' + this.ssid]) {
            this.hasServiceCheckListACL[this.acl['setting-' + this.ssid][key]] = true;
        }
    }
}

export default ServiceSettingsController;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/service_settings.controller.js